export enum AUTH_STATE {
	LOG_IN = 'log-in',
	SIGN_UP = 'sign-up',
	RESET_PASSWORD = 'reset-password',
};